import React from "react";
import Top from "../../Top";
import Left from "../../Left";
import { Grid } from "@mui/material";
// import appliImg from "../../../assets/Images/appliImg.jpg";
// import { useNavigate } from "react-router-dom";
import FormControlLabel from "@mui/material/FormControlLabel";
import Switch from "@mui/material/Switch";

import "react-medium-image-zoom/dist/styles.css";
// import ApplicationScreen1 from "./ApplicationScreen1";
import ApplicationSlider from "./ApplicationSlider";

// const label = { inputProps: { "aria-label": "Switch demo" } };

function GuardApplication() {
  // const navigate = useNavigate();

  return (
    <>
      <Top />
      <Left />
      <div className="rightContent">
        <Grid container spacing={3} className="mainHeadingLine">
          <Grid item xs={12} md={12} className="oneLineBt">
            <h1 className="panelHeading">Guard Application</h1>
          </Grid>
          <Grid item xs={12} md={12}>
            <div className="residentManagementTable">
              <div className="visitorListNewOut">
                <div className="visitorHead applicationHead">
                  Guard Application{" "}
                  <span className="applicSwitch">
                    <FormControlLabel
                      control={<Switch />}
                      label="Access to All Screens & Field"
                    />
                  </span>
                </div>
                <div className="applicationListNewInner">
                  <ApplicationSlider />
                </div>
              </div>
            </div>
          </Grid>
        </Grid>
      </div>
    </>
  );
}

export default GuardApplication;
